import React from "react";
import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { TestLanguage } from "types/testTypes";
import { LANGUAGE_DATA_MAP } from "@constants/languageConstants";

interface VADownloadProgressModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedLanguages: TestLanguage[];
}

const VADownloadProgressModal: React.FC<VADownloadProgressModalProps> = ({
  opened,
  onClose,
  onConfirm,
  selectedLanguages,
}) => {
  const { t } = useTranslation();

  return (
    <Modal opened={opened} onClose={onClose} title={t("vaDownloadTitle")}>
      <Stack gap="md">
        <Text size="sm">{t("vaDownloadDescription")}</Text>

        <Stack gap="xs">
          {selectedLanguages.map((lang) => (
            <Text key={lang} size="sm">
              {t(LANGUAGE_DATA_MAP[lang].translationKey)}
            </Text>
          ))}
        </Stack>

        <Group justify="flex-end">
          <Button variant="outline" onClick={onClose}>
            {t("cancel")}
          </Button>
          <Button onClick={onConfirm}>{t("install")}</Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default VADownloadProgressModal;
